import { createContext } from "react";

export default createContext({
  isLoggedIn: false,
  signIn: () => {},
  signOut: () => {},
});
